<map-marker
  #marker
  [position]="pinCoordinates"
  [options]="markerOptions"
  (mapClick)="showPin(pin.timeline_id)"
></map-marker>
  <map-info-window #infoWindow="mapInfoWindow" (clickOutside)="infoWindow.close()">
    <div *ngIf="this.selectedListing" class="map-info-window">
      <div class="title-row">
        <div class="info-window-title">{{ selectedListing.title() }}</div>
        <div class="savings">
          <savings-link [savingsInCents]="selectedListing.savings_in_cents"></savings-link>
        </div>
      </div>
      <div class="info-window-content">
        <div class="image-wrapper">
          <img *ngIf="(selectedListing.lead_photo_url && selectedListing.lead_photo_url.length)" style="width: 100%" [src]="selectedListing.lead_photo_url" />
        <img *ngIf="!(selectedListing.lead_photo_url && selectedListing.lead_photo_url.length)" style="width: 100%" src="assets/houwzer/houwzer-coming-soon-gray.png" />
      </div>
      <div class="">
        <div class="listing-info"><span class="listing-info-value">{{ headlineText() }}</span></div>
        <div class="d-flex">
          <div class="listing-info"><span class="listing-info-value">{{ selectedListing.timelineFieldValue('bedrooms') }}</span> beds</div>
          <div class="listing-info ml-2"><span class="listing-info-value">{{ selectedListing.bathrooms() }}</span> baths</div>
        </div>
        <div class="listing-info"><span class="listing-info-value">{{ selectedListing.totalFinishedSqft() }}</span> sqft</div>
        <div class="listing-link" *ngIf="selectedListing.listing_url">
          <a textCta target="_blank" [routerLink]="selectedListing.listing_url">View Full Listing</a>
        </div>
      </div>
    </div>
    </div>
  </map-info-window>

